import { Component, OnInit, ViewChild, ElementRef, Input } from "@angular/core";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { Chart } from "chart.js";
import { AnalyticsService } from "src/app/api/analytics.service";
import * as moment from "moment";

import { LoadingController } from "@ionic/angular";
import { AppSettings } from "src/app/app-settings";
@Component({
  selector: "app-analytics",
  templateUrl: "./analytics.page.html",
  styleUrls: ["./analytics.page.scss"],
})
export class AnalyticsPage implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  @ViewChild("barChart") barChart;
  @ViewChild("bar") bar;
  // public isLoading: boolean = false;
  public rowsRFQ: any[] = [];
  public colsRFQ: any[] = [];
  public rowsWTB: any[] = [];
  public colsWTB: any[] = [];
  public newFormattedValues: any[] = [];
  public kpis: {};
  public posts: {};
  public usersConnected: {};
  public nbUsersConnectedPerDay: any;
  public nbPostsPerDay: {};
  public isLoading: boolean = false;
  isWeb = AppSettings.IS_WEB;
  constructor(
    private analyticsService: AnalyticsService,
    private loadingCtrl: LoadingController
  ) {}

  ngOnInit() {}

  async ionViewDidEnter() {
    this.NbPostsPerDayBarChart();
    this.getKpisInfos();
    this.getTop10RFQ();
    this.getTop10WTB();
  }

  formatDate(date) {
    return new Date(date).toUTCString().slice(0, -25);
  }

  async getKpisInfos() {
    let t = this;
    let loader = await this.loadingCtrl.create({
      message: "Loading...",
    });

    loader.present();
    this.analyticsService
      .getKpis()
      .then((r) => {
        t.kpis = r;
        for (const [key, value] of Object.entries(t.kpis)) {
          t.kpis[key] = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        }
        loader.dismiss();
      })
      .catch(() => {
        t.loadingCtrl.dismiss();
      });
  }

  // NbUsersConnectedPerDayChart() {
  //   this.usersConnected = {
  //     "2022-05-06": 5,
  //     "2022-05-07": 10,
  //     "2022-05-08": 0,
  //     "2022-05-09": 2,
  //     "2022-05-10": 3,
  //     "2022-05-11": 8,
  //     "2022-05-12": 6,
  //   };
  //   let datas = [];
  //   let labels = [];
  //   for (const [key, value] of Object.entries(this.usersConnected)) {
  //     datas.push(value);
  //     labels.push(moment(key).format("MMM Do"));
  //   }
  //   this.nbUsersConnectedPerDay = new Chart(this.barChart.nativeElement, {
  //     type: "bar",
  //     data: {
  //       labels: labels,
  //       datasets: [
  //         {
  //           label: "Users",
  //           data: datas,
  //           backgroundColor: "#002E6E", // array should have same number of elements as number of dataset
  //           borderColor: "#002E6E", // array should have same number of elements as number of dataset
  //           borderWidth: 1,
  //         },
  //       ],
  //     },
  //   });
  // }

  async NbPostsPerDayBarChart() {
    let t = this;
    let loader = await this.loadingCtrl.create({
      message: "Loading...",
    });
    loader.present();
    this.analyticsService
      .getNbPostsPerDay()
      .then((r) => {
        this.nbPostsPerDay = r;

        let datas = [];
        let labels = [];
        for (const [key, value] of Object.entries(this.nbPostsPerDay)) {
          datas.push(value);
          labels.push(moment(key).format("MMM Do"));
        }

        this.nbPostsPerDay = new Chart(this.bar.nativeElement, {
          type: "bar",
          data: {
            labels: labels,
            datasets: [
              {
                label: "Posts",
                data: datas,
                backgroundColor: "#002E6E", // array should have same number of elements as number of dataset
                borderColor: "#002E6E", // array should have same number of elements as number of dataset
                borderWidth: 1,
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
          },
        });
        loader.dismiss();
      })
      .catch(() => {
        t.loadingCtrl.dismiss();
      });
  }

  getTop10RFQ() {
    let t = this;
    this.isLoading = true;
    this.analyticsService
      .getTopRfq()
      .then((r) => {
        let temp_cols = [];
        let temp_rows = [];
        temp_rows.push(r);
        this.rowsRFQ = temp_rows[0];
        for (var cols in temp_rows[0][0]) {
          temp_cols.push({ name: cols.replace("_", " "), prop: cols });
        }
        t.colsRFQ = temp_cols;
        this.isLoading = false;
      })
      .catch((e) => {
        this.rowsRFQ = [];
      });
  }

  getTop10WTB() {
    let t = this;
    this.isLoading = true;
    this.analyticsService
      .getTopWtb()
      .then((r) => {
        let temp_cols = [];
        let temp_rows = [];
        temp_rows.push(r);
        this.rowsWTB = temp_rows[0];
        for (var cols in temp_rows[0][0]) {
          temp_cols.push({ name: cols.replace("_", " "), prop: cols });
        }
        t.colsWTB = temp_cols;
        this.isLoading = false;
      })
      .catch((e) => {
        this.rowsWTB = [];
      });
  }
}
